import axiosService from '../utils/axios';
import { JamBoardPin, JamBoardPinApplicant } from '../types/jamboard';

export async function fetchJamBoardPins(): Promise<JamBoardPin[]> {
    const { data } = await axiosService.get<JamBoardPin[]>('/jamboard/pins');
    return data;
}

export async function fetchJamBoardPinsByAuthorUserId(
    userId: string
): Promise<JamBoardPin[]> {
    const { data } = await axiosService.get<JamBoardPin[]>(
        `/jamboard/pins/by-author/${encodeURIComponent(userId)}`
    );
    return data;
}

export async function fetchMyJamBoardPinCount(): Promise<{ count: number; userId: string }> {
    const { data } = await axiosService.get<{ count: number; userId: string }>(
        '/jamboard/pins/me/count'
    );
    return { count: data.count ?? 0, userId: data.userId };
}

export type JamBoardPinApplicationStatus = 'pending' | 'accepted';

export async function fetchMyJamBoardActiveApplicationStatuses(): Promise<
    Record<string, JamBoardPinApplicationStatus>
    > {
    const { data } = await axiosService.get<{
        statusByPinId: Record<string, JamBoardPinApplicationStatus>;
    }>('/jamboard/pins/me/active-application-pin-ids');
    return data.statusByPinId || {};
}

export interface JamBoardPinColorHold {
    token: string;
    pinColor: string;
}

export async function claimJamBoardPinColor(): Promise<JamBoardPinColorHold> {
    const { data } = await axiosService.post<JamBoardPinColorHold>('/jamboard/pins/color');
    return data;
}

export async function createJamBoardPin(formData: FormData): Promise<unknown> {
    const { data } = await axiosService.post('/jamboard/pins', formData);
    return data;
}

export async function deleteJamBoardPin(pinId: string): Promise<void> {
    await axiosService.delete(`/jamboard/pins/${pinId}`);
}

export async function updateJamBoardPin(
    pinId: string,
    formData: FormData
): Promise<unknown> {
    const { data } = await axiosService.patch(
        `/jamboard/pins/${pinId}`,
        formData
    );
    return data;
}

export async function applyToJamBoardPin(pinId: string): Promise<void> {
    await axiosService.post(`/jamboard/pins/${pinId}/apply`);
}

export async function fetchMyPinApplicantCounts(): Promise<Record<string, number>> {
    const { data } = await axiosService.get<{ counts: Record<string, number> }>(
        '/jamboard/pins/me/applicant-counts'
    );
    return data.counts || {};
}

export async function fetchJamBoardPinApplicants(
    pinId: string
): Promise<JamBoardPinApplicant[]> {
    const { data } = await axiosService.get<{ applicants: JamBoardPinApplicant[] }>(
        `/jamboard/pins/${pinId}/applicants`
    );
    return data.applicants || [];
}

export async function denyJamBoardPinApplicant(
    pinId: string,
    collabId: string
): Promise<void> {
    await axiosService.post(`/jamboard/pins/${pinId}/applicants/${collabId}/deny`);
}
